/* eslint-disable */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {StyleSheet, css} from 'aphrodite';

import {mapStateToProps, mapDispatchToProps} from '../../utils';
import {updateAppState} from '../../actions/applicationState';
import {getCurrentMember, updateUser, resendVerification} from '../../actions/user';

import {Theme} from '../../config/theme';
import Body from '../../components/Body';
import UnauthenticatedHeader from '../../components/UnauthenticatedHeader';

let styles;

class Verify extends Component {
  constructor(props) {
    super(props);

    this.state = {
      verified: false,
      verifyingSent: false,
    };

    this.openLoginHandler = this.loginModalOpenHandler.bind(this);
    this.resendVerification = this.resendVerification.bind(this);
  }

  loginModalOpenHandler() {
    this.props.dispatch(updateAppState({
      login_modal_open: true,
    }));
  }

  resendVerification() {
    this.setState({
      verifyingSent: true,
    });
    this.props.dispatch(
      resendVerification(this.props.user.email)
    ).then((response) => {
      if (response.status === 200) {
        this.setState({
          verifyingSent: true,
        });
      } else {
        this.setState({
          verifyingSent: false,
        });
      }
    }, (err) => {
      if (err.status === 503) {
        this.setState({
          verified: true,
        });
        this.props.dispatch(getCurrentMember(this.props.user.id, this.props.user.access_token))
          .then((response) => {
            this.props.dispatch(updateUser(response));

            this.props.dispatch(updateAppState({
              loading: false,
            }));
          });
      }
    });
  }

  render() {
    return (
      <Body hasFooter>
      <UnauthenticatedHeader openLoginHandler={this.openLoginHandler}/>
      {
        <div className={css(styles.container)}>
          <h2 className={css(styles.subtitle)}>Thank you for joining The Dog Share Collective.</h2>
          {this.state.verified ?
            <p className={css(styles.paragraph)}>Your account is already verified.</p>
            :
            <div>
              { this.state.verifyingSent ?
                <p className={css(styles.paragraph)}>
                  Your email verification has been resent.
                </p>
                :
                <p className={css(styles.paragraph)}>
                  To finish activating your account, please follow the link in the email we have sent you.
                  If you need another email verifiction please click <a className={css(styles.anchor)} onClick={this.resendVerification}>here</a>.
                </p>
              }
            </div>
          }
        </div>
      }
      </Body>
    );
  }
}

Verify.propTypes = {
  dispatch: PropTypes.func.isRequired,
};


styles = StyleSheet.create({
  container: {
    padding: '70px 15px',
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 515,
    marginTop: 80,
    flexDirection: 'column',
  },
  title: {
    fontFamily: Theme.font_family_heading,
    fontSize: 60,
    fontWeight: Theme.font_weight_heading,
    color: Theme.black,
    marginBottom: 30,

    [Theme.mobile_query]: {
      fontSize: 45,
    },
  },
  subtitle: {
    fontFamily: Theme.font_family_heading,
    fontSize: 40,
    fontWeight: Theme.font_weight_heading,
    color: Theme.black,
    marginBottom: 30,

    [Theme.mobile_query]: {
      fontSize: 25,
    },
  },
  message: {
    fontFamily: Theme.font_family_heading,
    fontSize: 30,
    fontWeight: Theme.font_weight_heading,
    color: Theme.black,

    [Theme.mobile_query]: {
      fontSize: 25,
    },
  },
  login_link: {
    cursor: 'pointer',
  },
  anchor: {
    cursor: 'pointer',
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Verify);



// WEBPACK FOOTER //
// ./src/views/JoinVerify/index.js